const s = {
  name: "Desktop",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.2,5c0,0.7-0.6,1.2-1.2,1.2S18.8,5.7,18.8,5s0.6-1.3,1.2-1.3S21.2,4.3,21.2,5z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v24c0,1.7-1.3,3-3,3H24.2l0.7,4H28v2H12v-2h3.2l0.7-4H3
			c-1.7,0-3-1.3-3-3V3z M37,28c0.5,0,1-0.5,1-1V3c0-0.5-0.5-1-1-1H3C2.5,2,2,2.5,2,3v24c0,0.5,0.5,1,1,1H37z M17.8,30l-0.7,4h5.6
			l-0.7-4H17.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Desktop
};
